export default {
  methods: {
    mixin_copy(text) {
      this.$copyText(text)
        .then(res => {
          this.$message.success('复制成功')
        })
        .catch(err => {
          this.$message.error('复制失败')
        })
    }
  }
}